import { getPaimentData } from "src/utils/dashboard";
import { useSelector } from "react-redux";
import BarChartTotalHolding from "../Chart/BarChartHoldingTotal";
import { InfoCard } from "./utils/InfoCard";
import { formatMoneyWithCurrency } from "src/utils/formatter";
import { groupByCompanyId, sumDebtsForCompanies } from "./utils/functions";
import { useMemo, useState } from "react";
import { GetCompanyData } from "src/graphql/company";
import { ResumeMonthToPay } from "./utils/PorCobrarComponents/ResumeMonthToPay";

export const PorCobrar = ({ source, loading }) => {

  const [mostDebtCompany, setMostDebtCompany] = useState('')
  const [lessDebtCompany, setLessDebtCompany] = useState('')

  const { data: companyMostData } = GetCompanyData(mostDebtCompany)
  const { data: companyLessData } = GetCompanyData(lessDebtCompany)

  const { selectedClient, selectedFilter } = useSelector(
    (state) => state.dashboard
  );

  let paimentData = getPaimentData(
    { 0: source?.findPaymentCollectionHolding },
    selectedClient,
    selectedFilter.getElement || null
  );

  const labels = paimentData[0]?.legend;
  const data = paimentData[0]?.dashboardData;


  const {
    numberOfCompanies = 0,
    groupedData = [],
  } = useMemo(() => {
    if (!source) return {}

    const result = sumDebtsForCompanies(source.findPaymentCollectionHolding);
    const companyMostDebt = result.reduce((max, empresa) =>
      empresa.totalDebt > max.totalDebt ? empresa : max
    );
    const companyLessDebt = result.reduce((min, empresa) =>
      empresa.totalDebt < min.totalDebt ? empresa : min
    );

    const groupedData = groupByCompanyId(source.findPaymentCollectionHolding);

    setMostDebtCompany(companyMostDebt.companyId)
    setLessDebtCompany(companyLessDebt.companyId)

    return {
      numberOfCompanies: result.length,
      groupedData: groupedData,
    }

  }, [source])

  const companyName = companyMostData?.Company?.alias || companyMostData?.Company?.name || ''
  const companyLessName = companyLessData?.Company?.alias || companyLessData?.Company?.name || ''

  const CardInfo = [
    {
      id: 'totalAmount',
      name: 'Monto Total',
      amount: formatMoneyWithCurrency(paimentData[0]?.dashboardData[0]?.entireAmount),
      classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
      classTitle: 'tw-text-gray-600 tw-capitalize',
      classAmount: 'tw-text-black'
    },
    {
      id: 'totalAmountCurrent',
      name: 'Monto total al día',
      amount: formatMoneyWithCurrency(paimentData[0]?.dashboardData[0]?.currentPay),
      classBG: 'tw-bg-[#1D7EE3]',
      classTitle: 'tw-text-white tw-capitalize',
      classAmount: 'tw-text-white'
    },
    {
      id: 'totalAmountLate',
      name: 'Monto total atrasado',
      amount: formatMoneyWithCurrency(paimentData[0]?.dashboardData[0]?.duePay),
      classBG: 'tw-bg-[#EAB308]',
      classTitle: 'tw-text-white tw-capitalize',
      classAmount: 'tw-text-white'
    },

  ]

  const CardInfo2 = [
    {
      id: 'companyToPayMore',
      name: 'Empresa con mayor monto por cobrar',
      amount: companyName,
      subAmount: 'currentYear',
      classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
      classTitle: 'tw-text-gray-600',
      classAmount: 'tw-text-black',
      classSubAmount: 'tw-text-black'
    },
    {
      id: 'companyToPayLess',
      name: 'Empresa con menor monto por cobrar',
      amount: companyLessName,
      subAmount: 'currentYear',
      classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
      classTitle: 'tw-text-gray-600',
      classAmount: 'tw-text-black',
      classSubAmount: 'tw-text-black'
    },
    {
      id: 'totalCompanys',
      name: 'Total de empresas',
      amount: numberOfCompanies,
      subAmount: 'currentYear',
      classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
      classTitle: 'tw-text-gray-600',
      classAmount: 'tw-text-black tw-capitalize',
    },
  ]
  

  return (
    <>
    {
      source ? (
        <>
        
        
      <div className="tw-flex tw-flex-col tw-gap-10 tw-w-full tw-bg-white tw-rounded-md tw-p-7">
        <div>
          <p className="tw-font-medium tw-text-xl tw-text-black">Resumen consolidado de cuentas por cobrar</p>
        </div>
        <div className="tw-flex tw-gap-6">
          {CardInfo.map((item, index) => (
            <InfoCard
              key={index}
              name={item.name}
              subName={item.subName}
              amount={item.amount}
              classBG={item.classBG}
              classTitle={item.classTitle}
              classAmount={item.classAmount}
              classDiv={item.classDiv}
            />
          ))}
        </div>
        <div className="tw-mt-4">
          <BarChartTotalHolding labels={labels} data={data} color={"#1D7EE3"} isToPay={false} />
        </div>
        <div className="tw-flex tw-gap-6">
          {CardInfo2.map((item, index) => (
            <InfoCard
              key={index}
              name={item.name}
              subName={item.subName}
              amount={item.amount}
              classBG={item.classBG}
              classTitle={item.classTitle}
              classAmount={item.classAmount}
              classDiv={item.classDiv}
            />
          ))}
        </div>
      </div>
      <div className="tw-bg-white tw-rounded-md tw-p-7 tw-flex tw-flex-col tw-gap-10 tw-mt-6">
        <div>
          <p className="tw-font-medium tw-text-xl tw-text-black">Resumen de cuentas por cobrar por empresa</p>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-6">
          {groupedData.map((company, index) => (
            <ResumeMonthToPay
              key={company.companyId}
              source={company.items}
              companyId={company.companyId}
              isToPay={true}
            />
          ))}
        </div>
      </div>
      </>
      ):
        (
          <div class="tw-bg-white tw-rounded-md tw-p-6">
            <div className="tw-flex tw-gap-6 tw-h-[13vh]">
              <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
              <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
              <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
              <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
            </div>
            <div class="tw-flex tw-items-end tw-gap-6 tw-w-full tw-h-[43vh]">
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[20vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[25vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[35vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[32vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[23vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[30vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[21vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[18vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[24vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[27vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[10vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[29vh]"></div>
              <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[16vh]"></div>
            </div>
          </div>
        )
      
    }
    </>
  )
}